
import { toFail, isNullOrWhiteSpace, printf, toText, concat } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { dataTooltip } from "../../fable_modules/Fulma.Extensions.Wikiki.Tooltip.4.0.0/Tooltip.fs.js";
import * as react_2 from "react";
import { keyValueList } from "../../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { makeInequalityConstraint, EqualityConstraint, isEqu, ConstraintType, CellIO__get_getWidth, Constraint, CellIO__get_getLabel } from "../../Simulator/TruthTableTypes.js";
import { filter, isEmpty, head, contains, fold, append, ofArray, singleton, empty, map } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { right, left, level, Item_Option, item } from "../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { list as list_3, Option, tag as tag_52 } from "../../fable_modules/Fulma.3.0.0/Elements/Tag.fs.js";
import { Color_IColor } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Option as Option_1, delete$ } from "../../fable_modules/Fulma.3.0.0/Elements/Delete.fs.js";
import { Msg, TTMsg } from "../../Model/ModelType.js";
import { arrayHash, equalArrays, safeHash, equals } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { strToIntCheckWidth, convertIntToWireData, convertWireDataToInt } from "../../Simulator/NumberHelpers.js";
import { toInt32, fromZero, compare, equals as equals_1, fromInt32 } from "../../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { Result_IsOk, FSharpResult$2 } from "../../fable_modules/fable-library-js.5.13.0/Result.js";
import { Option as Option_2, button } from "../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Option as Option_3, div } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { div as div_1 } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Control.fs.js";
import { input } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option as Option_4, IInputType } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { baseSelector, viewNum } from "../MemoryEditorView.js";
import { NumberBase } from "../../Common/CommonTypes.js";
import { constraintNumberStyle } from "../Style.js";
import { getTextEventValue } from "../../Interface/JSHelpers.js";
import { makeIOLabel } from "../SimulationView.js";
import { h5, h6 } from "../../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { dynamicClosablePopup, dialogPopup } from "../../DrawBlock/PopupHelpers.js";
import { toList } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { errMsg, FastAlgExp, FSInterface, FastData, FastBits, AlgebraNotImplemented } from "../../Simulator/SimGraphTypes.js";
import { changeInputFData } from "../../Simulator/FastSim/FastExtract.js";
import { toString } from "../../fable_modules/fable-library-js.5.13.0/Types.js";
import { errorMessage } from "../ErrorDisplay.js";

/**
 * Adds a tooltip to a ReactElement which appears above the element
 */
export function addToolTipTop(tip, react) {
    const props = [new HTMLAttr(/* ClassName */ 64, [concat("tooltip", " has-tooltip-top")]), dataTooltip(tip)];
    return react_2.createElement("div", keyValueList(props, 1), react);
}

/**
 * Adds a tooltip to a ReactElement which appears to the right of the element
 */
export function addToolTipRight(tip, react) {
    const props = [new HTMLAttr(/* ClassName */ 64, [concat("tooltip", " has-tooltip-right")]), dataTooltip(tip)];
    return react_2.createElement("div", keyValueList(props, 1), react);
}

/**
 * Convert a constraint to its string representation
 */
export function inCon2str(con) {
    if (con.tag === 1) {
        const i = con.fields[0];
        const arg_3 = CellIO__get_getLabel(i.IO);
        return toText(printf("0x%X ≤ %s ≤ 0x%X"))(i.LowerBound)(arg_3)(i.UpperBound);
    }
    else {
        const e = con.fields[0];
        const arg = CellIO__get_getLabel(e.IO);
        return toText(printf("%s = 0x%X"))(arg)(e.Value);
    }
}

export function makeElementLine(elsLeftAlign, elsRightAlign) {
    const itemListLeft = map((el) => item(empty(), singleton(el)), elsLeftAlign);
    const itemListRight = map((el_1) => item(singleton(new Item_Option(/* Props */ 0, [singleton(["style", {
        width: "200px",
        float: "left",
    }])])), singleton(el_1)), elsRightAlign);
    return level(empty(), ofArray([left(empty(), itemListLeft), right(empty(), itemListRight)]));
}

/**
 * View a list of numerical constraints in tag form, with delete buttons
 */
export function viewNumericalConstraints(cons, dispatch) {
    const makeConTag = (con) => tag_52(ofArray([new Option(/* Color */ 1, [Color_IColor.IsInfo]), Option.IsLight]), ofArray([inCon2str(con), delete$(singleton(new Option_1(/* OnClick */ 3, [(_arg) => {
        dispatch(new TTMsg(/* DeleteInputConstraint */ 11, [con]));
        dispatch(new TTMsg(/* DeleteOutputConstraint */ 12, [con]));
    }])), empty())]));
    return list_3(empty(), append(map((con_1) => makeConTag(new Constraint(/* Equality */ 0, [con_1])), cons.Equalities), map((con_2) => makeConTag(new Constraint(/* Inequality */ 1, [con_2])), cons.Inequalities)));
}

/**
 * Return true if two constraints overlap
 * Example 1: 2 < X < 7 and 5 < X < 21
 * Example 2: 2 < X < 7 and X = 4
 */
export function constraintsOverlap(con1, con2) {
    const equAndIneqOverlap = (equ, ineq) => {
        if (equals(equ.IO, ineq.IO) && (equ.Value >= ineq.LowerBound)) {
            return equ.Value <= ineq.UpperBound;
        }
        else {
            return false;
        }
    };
    const checkTwoIneq = (in1, in2) => {
        if (equals(in1.IO, in2.IO)) {
            if ((in1.LowerBound >= in2.LowerBound) && (in1.LowerBound <= in2.UpperBound)) {
                return true;
            }
            else if (in1.UpperBound >= in2.LowerBound) {
                return in1.UpperBound <= in2.UpperBound;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    if (con1.tag === 1) {
        if (con2.tag === 1) {
            if (checkTwoIneq(con1.fields[0], con2.fields[0])) {
                return true;
            }
            else {
                return checkTwoIneq(con2.fields[0], con1.fields[0]);
            }
        }
        else {
            return equAndIneqOverlap(con2.fields[0], con1.fields[0]);
        }
    }
    else if (con2.tag === 1) {
        return equAndIneqOverlap(con1.fields[0], con2.fields[0]);
    }
    else {
        return equals(con1.fields[0], con2.fields[0]);
    }
}

/**
 * Check if a newly added numerical constraint is valid and consistent with current constraints
 */
export function validateNumericalConstraint(con, allConstraints) {
    const conText = inCon2str(con);
    if (con.tag === 1) {
        const ineq = con.fields[0];
        const width = CellIO__get_getWidth(ineq.IO) | 0;
        const unsignedLower = convertWireDataToInt(convertIntToWireData(width, fromInt32(ineq.LowerBound)));
        const unsignedUpper = convertWireDataToInt(convertIntToWireData(width, fromInt32(ineq.UpperBound)));
        if (equals_1(unsignedLower, unsignedUpper)) {
            return new FSharpResult$2(/* Error */ 1, ["Lower Bound and Upper Bound cannot have the same value."]);
        }
        else if (compare(unsignedLower, unsignedUpper) > 0) {
            return new FSharpResult$2(/* Error */ 1, ["Lower Bound cannot have a greater value than Upper Bound"]);
        }
        else {
            const _arg_1 = fold((state_4, c_2) => {
                if (state_4.tag === 0) {
                    if (constraintsOverlap(con, new Constraint(/* Inequality */ 1, [c_2]))) {
                        const constr_2 = inCon2str(new Constraint(/* Inequality */ 1, [c_2]));
                        return new FSharpResult$2(/* Error */ 1, [toText(printf("This constraint overlaps with another constraint: %s.\r\n                            Please change your new constraint or delete the old one."))(constr_2)]);
                    }
                    else {
                        return new FSharpResult$2(/* Ok */ 0, [state_4.fields[0]]);
                    }
                }
                else {
                    return new FSharpResult$2(/* Error */ 1, [state_4.fields[0]]);
                }
            }, fold((state_2, c_1) => {
                if (state_2.tag === 0) {
                    if (constraintsOverlap(con, new Constraint(/* Equality */ 0, [c_1]))) {
                        const constr_1 = inCon2str(new Constraint(/* Equality */ 0, [c_1]));
                        return new FSharpResult$2(/* Error */ 1, [toText(printf("This constraint overlaps with another constraint: %s.\r\n                            Please change your new constraint or delete the old one."))(constr_1)]);
                    }
                    else {
                        return new FSharpResult$2(/* Ok */ 0, [state_2.fields[0]]);
                    }
                }
                else {
                    return new FSharpResult$2(/* Error */ 1, [state_2.fields[0]]);
                }
            }, new FSharpResult$2(/* Ok */ 0, [ineq]), allConstraints.Equalities), allConstraints.Inequalities);
            if (_arg_1.tag === 0) {
                return new FSharpResult$2(/* Ok */ 0, [new Constraint(/* Inequality */ 1, [_arg_1.fields[0]])]);
            }
            else {
                return new FSharpResult$2(/* Error */ 1, [_arg_1.fields[0]]);
            }
        }
    }
    else {
        const e = con.fields[0];
        if (contains(e, allConstraints.Equalities, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        })) {
            return new FSharpResult$2(/* Error */ 1, [toText(printf("Constraint \'%s\' already exists."))(conText)]);
        }
        else {
            const _arg = fold((state, c) => {
                if (state.tag === 0) {
                    if (constraintsOverlap(con, new Constraint(/* Inequality */ 1, [c]))) {
                        const constr = inCon2str(new Constraint(/* Inequality */ 1, [c]));
                        return new FSharpResult$2(/* Error */ 1, [toText(printf("This constraint overlaps with another constraint: %s.\r\n                        Please change your new constraint or delete the old one."))(constr)]);
                    }
                    else {
                        return new FSharpResult$2(/* Ok */ 0, [state.fields[0]]);
                    }
                }
                else {
                    return new FSharpResult$2(/* Error */ 1, [state.fields[0]]);
                }
            }, new FSharpResult$2(/* Ok */ 0, [e]), allConstraints.Inequalities);
            if (_arg.tag === 0) {
                return new FSharpResult$2(/* Ok */ 0, [new Constraint(/* Equality */ 0, [_arg.fields[0]])]);
            }
            else {
                return new FSharpResult$2(/* Error */ 1, [_arg.fields[0]]);
            }
        }
    }
}

/**
 * Body of the popup for adding input/output numerical constraints
 */
export function dialogPopupNumericalConBody(cellIOs, existingCons, infoMsg, dispatch) {
    const ttDispatch = (ttMsg) => {
        dispatch(new Msg(/* TruthTableMsg */ 32, [ttMsg]));
    };
    return (model$0027) => {
        let arg_3, arg_2;
        const dialogData = model$0027.PopupDialogData;
        let selected;
        const matchValue = dialogData.ConstraintIOSel;
        if (matchValue != null) {
            selected = matchValue;
        }
        else {
            ttDispatch(new TTMsg(/* SetPopupConstraintIOSel */ 26, [head(cellIOs)]));
            selected = head(cellIOs);
        }
        let ioSelect;
        const buttons = map((io_1) => {
            const action = (_arg) => {
                ttDispatch(new TTMsg(/* SetPopupConstraintIOSel */ 26, [io_1]));
                ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [undefined]));
            };
            return button(equals(io_1, selected) ? ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_2(/* OnClick */ 18, [action])]) : singleton(new Option_2(/* OnClick */ 18, [action])), singleton(CellIO__get_getLabel(io_1)));
        }, cellIOs);
        ioSelect = react_2.createElement("div", {}, ...buttons);
        let typeSelect;
        if (CellIO__get_getWidth(selected) === 1) {
            ttDispatch(new TTMsg(/* SetPopupConstraintTypeSel */ 25, [ConstraintType.Equ]));
            typeSelect = item(singleton(Item_Option.HasTextCentered), singleton(div(singleton(Option_3.HasAddonsCentered), singleton(div_1(empty(), singleton(button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_2(/* OnClick */ 18, [(_arg_1) => {
                ttDispatch(new TTMsg(/* SetPopupConstraintTypeSel */ 25, [ConstraintType.Equ]));
            }])]), singleton("Equality Constraint"))))))));
        }
        else {
            const matchValue_1 = dialogData.ConstraintTypeSel;
            if (matchValue_1 != null) {
                const x = matchValue_1;
                typeSelect = item(singleton(Item_Option.HasTextCentered), singleton(div(singleton(Option_3.HasAddonsCentered), ofArray([div_1(empty(), singleton(button(ofArray([new Option_2(/* Color */ 0, [isEqu(x) ? Color_IColor.IsPrimary : Color_IColor.NoColor]), new Option_2(/* OnClick */ 18, [(_arg_2) => {
                    ttDispatch(new TTMsg(/* SetPopupConstraintTypeSel */ 25, [ConstraintType.Equ]));
                    ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [undefined]));
                }])]), singleton("Equality Constraint")))), div_1(empty(), singleton(button(ofArray([new Option_2(/* Color */ 0, [!isEqu(x) ? Color_IColor.IsPrimary : Color_IColor.NoColor]), new Option_2(/* OnClick */ 18, [(_arg_3) => {
                    ttDispatch(new TTMsg(/* SetPopupConstraintTypeSel */ 25, [ConstraintType.Ineq]));
                    ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [undefined]));
                }])]), singleton("Inequality Constraint"))))]))));
            }
            else {
                ttDispatch(new TTMsg(/* SetPopupConstraintTypeSel */ 25, [ConstraintType.Equ]));
                typeSelect = react_2.createElement("div", {});
            }
        }
        const numField1 = (width) => input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Key */ 9, ["Hex"]), new Option_4(/* DefaultValue */ 10, [viewNum(NumberBase.Hex)(fromZero())]), new Option_4(/* Props */ 15, [ofArray([constraintNumberStyle, new DOMAttr(/* OnChange */ 9, [(arg) => {
            const text = getTextEventValue(arg);
            const matchValue_2 = strToIntCheckWidth(width, text);
            const matchValue_3 = isNullOrWhiteSpace(text);
            if (matchValue_3) {
                ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, ["Blank constraint field"]));
            }
            else {
                const copyOfStruct = matchValue_2;
                if (copyOfStruct.tag === 0) {
                    ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [undefined]));
                    dispatch(new Msg(/* SetPopupDialogInt */ 57, [~~toInt32(copyOfStruct.fields[0])]));
                }
                else {
                    ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [copyOfStruct.fields[0]]));
                }
            }
        }])])])]));
        let constraintEditor;
        const matchValue_8 = dialogData.ConstraintTypeSel;
        const matchValue_9 = dialogData.ConstraintIOSel;
        if (matchValue_8 != null) {
            if (matchValue_9 != null) {
                if (matchValue_8.tag === 1) {
                    const io_3 = matchValue_9;
                    const matchValue_13 = CellIO__get_getLabel(io_3);
                    const width_3 = CellIO__get_getWidth(io_3) | 0;
                    constraintEditor = makeElementLine(ofArray([numField1(width_3), (arg_3 = makeIOLabel(matchValue_13, width_3), toText(printf("≤ %s ≤"))(arg_3)), input(ofArray([new Option_4(/* Type */ 1, [IInputType.Text$]), new Option_4(/* Key */ 9, ["Hex"]), new Option_4(/* DefaultValue */ 10, [viewNum(NumberBase.Hex)(fromZero())]), new Option_4(/* Props */ 15, [ofArray([constraintNumberStyle, new DOMAttr(/* OnChange */ 9, [(arg_1) => {
                        const text_1 = getTextEventValue(arg_1);
                        const matchValue_5 = strToIntCheckWidth(width_3, text_1);
                        const matchValue_6 = isNullOrWhiteSpace(text_1);
                        if (matchValue_6) {
                            ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, ["Blank constraint field"]));
                        }
                        else {
                            const copyOfStruct_1 = matchValue_5;
                            if (copyOfStruct_1.tag === 0) {
                                ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [undefined]));
                                dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [copyOfStruct_1.fields[0]]));
                            }
                            else {
                                ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [copyOfStruct_1.fields[0]]));
                            }
                        }
                    }])])])]))]), empty());
                }
                else {
                    const io_2 = matchValue_9;
                    const matchValue_11 = CellIO__get_getLabel(io_2);
                    const width_2 = CellIO__get_getWidth(io_2) | 0;
                    constraintEditor = makeElementLine(ofArray([(arg_2 = makeIOLabel(matchValue_11, width_2), toText(printf("%s = "))(arg_2)), numField1(width_2)]), empty());
                }
            }
            else {
                constraintEditor = react_2.createElement("div", {});
            }
        }
        else {
            constraintEditor = react_2.createElement("div", {});
        }
        let errorMsg;
        const matchValue_15 = dialogData.ConstraintErrorMsg;
        if (matchValue_15 != null) {
            const msg = matchValue_15;
            const children_10 = [react_2.createElement("hr", {}), msg];
            errorMsg = react_2.createElement("div", {}, ...children_10);
        }
        else {
            errorMsg = react_2.createElement("div", {});
        }
        const matchValue_16 = dialogData.Int;
        const matchValue_17 = dialogData.Int2;
        const matchValue_19 = dialogData.ConstraintIOSel;
        const matchValue_20 = dialogData.ConstraintTypeSel;
        let matchResult, io_4, v, io_5, lower, upper;
        if (matchValue_16 != null) {
            if (dialogData.ConstraintErrorMsg == null) {
                if (matchValue_19 != null) {
                    if (matchValue_20 != null) {
                        if (matchValue_20.tag === 1) {
                            if (matchValue_17 != null) {
                                matchResult = 1;
                                io_5 = matchValue_19;
                                lower = matchValue_16;
                                upper = matchValue_17;
                            }
                            else {
                                matchResult = 2;
                            }
                        }
                        else {
                            matchResult = 0;
                            io_4 = matchValue_19;
                            v = matchValue_16;
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
        switch (matchResult) {
            case 0: {
                const matchValue_22 = validateNumericalConstraint(new Constraint(/* Equality */ 0, [new EqualityConstraint(io_4, v)]), existingCons);
                if (matchValue_22.tag === 0) {
                    ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [undefined]));
                    ttDispatch(new TTMsg(/* SetPopupNewConstraint */ 28, [matchValue_22.fields[0]]));
                }
                else {
                    ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [matchValue_22.fields[0]]));
                }
                break;
            }
            case 1: {
                const matchValue_23 = validateNumericalConstraint(new Constraint(/* Inequality */ 1, [makeInequalityConstraint(lower, io_5, ~~toInt32(upper))]), existingCons);
                if (matchValue_23.tag === 0) {
                    ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [undefined]));
                    ttDispatch(new TTMsg(/* SetPopupNewConstraint */ 28, [matchValue_23.fields[0]]));
                }
                else {
                    ttDispatch(new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [matchValue_23.fields[0]]));
                }
                break;
            }
            case 2: {
                ttDispatch(new TTMsg(/* SetPopupNewConstraint */ 28, [undefined]));
                break;
            }
        }
        const children_12 = [infoMsg, react_2.createElement("hr", {}), h6(empty())(singleton("Select IO")), ioSelect, react_2.createElement("hr", {}), h6(empty())(singleton("Constraint Type")), typeSelect, react_2.createElement("hr", {}), h6(empty())(singleton("Edit Constraint")), constraintEditor, errorMsg];
        return react_2.createElement("div", {}, ...children_12);
    };
}

/**
 * Popup for creating a new input constraint
 */
export function createInputConstraintPopup(model, dispatch) {
    let matchValue, copyOfStruct;
    const ttDispatch = (ttMsg) => {
        dispatch(new Msg(/* TruthTableMsg */ 32, [ttMsg]));
    };
    dispatch(new Msg(/* SetPopupDialogInt */ 57, [0]));
    dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [fromZero()]));
    ttDispatch(new TTMsg(/* SetPopupConstraintTypeSel */ 25, [ConstraintType.Equ]));
    ttDispatch(new TTMsg(/* SetPopupConstraintIOSel */ 26, [undefined]));
    ttDispatch(new TTMsg(/* SetPopupNewConstraint */ 28, [undefined]));
    dialogPopup("Add Input Constraint", dialogPopupNumericalConBody((matchValue = model.CurrentTruthTable, (matchValue != null) ? ((copyOfStruct = matchValue, (copyOfStruct.tag === 0) ? map((cell) => cell.IO, head(map((tuple) => tuple[0], toList(copyOfStruct.fields[0].TableMap)))) : toFail(printf("what? Constraint add option should not exist when there is TT error")))) : toFail(printf("what? No current Truth Table when adding Constraints"))), model.TTConfig.InputConstraints, "The Truth Table is re-generated every time Input Constraints change.", dispatch), "Add", (model$0027) => {
        const matchValue_1 = model$0027.PopupDialogData.NewConstraint;
        if (matchValue_1 != null) {
            ttDispatch(new TTMsg(/* AddInputConstraint */ 9, [matchValue_1]));
            dispatch(Msg.ClosePopup);
        }
    }, (model$0027_1) => {
        const dialogData_1 = model$0027_1.PopupDialogData;
        let matchResult;
        if (dialogData_1.ConstraintErrorMsg == null) {
            if (dialogData_1.NewConstraint != null) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return false;
            default:
                return true;
        }
    }, empty(), dispatch);
}

/**
 * Popup for creating a new output constraint
 */
export function createOutputConstraintPopup(model, dispatch) {
    let matchValue, copyOfStruct;
    const ttDispatch = (ttMsg) => {
        dispatch(new Msg(/* TruthTableMsg */ 32, [ttMsg]));
    };
    dispatch(new Msg(/* SetPopupDialogInt */ 57, [0]));
    dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [fromZero()]));
    ttDispatch(new TTMsg(/* SetPopupConstraintTypeSel */ 25, [ConstraintType.Equ]));
    ttDispatch(new TTMsg(/* SetPopupConstraintIOSel */ 26, [undefined]));
    ttDispatch(new TTMsg(/* SetPopupNewConstraint */ 28, [undefined]));
    dialogPopup("Add Output Constraint", dialogPopupNumericalConBody((matchValue = model.CurrentTruthTable, (matchValue != null) ? ((copyOfStruct = matchValue, (copyOfStruct.tag === 0) ? map((cell) => cell.IO, head(map((tuple) => tuple[1], toList(copyOfStruct.fields[0].TableMap)))) : toFail(printf("what? Constraint add option should not exist when there is TT error")))) : toFail(printf("what? No current Truth Table when adding Constraints"))), model.TTConfig.OutputConstraints, "If the truth table is truncated, results from applying Output Constraints may not be complete.", dispatch), "Add", (model$0027) => {
        const matchValue_1 = model$0027.PopupDialogData.NewConstraint;
        if (matchValue_1 != null) {
            ttDispatch(new TTMsg(/* AddOutputConstraint */ 10, [matchValue_1]));
            dispatch(Msg.ClosePopup);
        }
    }, (model$0027_1) => {
        const dialogData_1 = model$0027_1.PopupDialogData;
        let matchResult;
        if (dialogData_1.ConstraintErrorMsg == null) {
            if (dialogData_1.NewConstraint != null) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return false;
            default:
                return true;
        }
    }, empty(), dispatch);
}

/**
 * View function for the constraints section on the right-tab
 */
export function viewConstraints(model, dispatch) {
    const ttDispatch = (ttMsg) => {
        dispatch(new Msg(/* TruthTableMsg */ 32, [ttMsg]));
    };
    const addButton = (action) => button(singleton(new Option_2(/* OnClick */ 18, [action])), singleton("Add"));
    const clearButton = (action_1) => button(singleton(new Option_2(/* OnClick */ 18, [action_1])), singleton("Clear All"));
    const children = ["Filter Rows in the Truth Table using Input or Output constraints", react_2.createElement("br", {}), react_2.createElement("br", {}), h6(empty())(singleton("Input Constraints")), viewNumericalConstraints(model.TTConfig.InputConstraints, ttDispatch), react_2.createElement("br", {}), makeElementLine(ofArray([addButton((_arg) => {
        createInputConstraintPopup(model, dispatch);
    }), clearButton((_arg_1) => {
        ttDispatch(TTMsg.ClearInputConstraints);
    })]), empty()), h6(empty())(singleton("Output Constraints")), viewNumericalConstraints(model.TTConfig.OutputConstraints, ttDispatch), react_2.createElement("br", {}), makeElementLine(ofArray([addButton((_arg_2) => {
        createOutputConstraintPopup(model, dispatch);
    }), clearButton((_arg_3) => {
        ttDispatch(TTMsg.ClearOutputConstraints);
    })]), empty())];
    return react_2.createElement("div", {}, ...children);
}

export function makeOnOffToggle(algIsAllowed, valueState, changeAction, onText, offText) {
    return item(singleton(Item_Option.HasTextCentered), singleton(div(singleton(Option_3.HasAddonsCentered), ofArray([div_1(empty(), singleton(button(ofArray([new Option_2(/* Color */ 0, [valueState ? Color_IColor.IsSuccess : Color_IColor.NoColor]), new Option_2(/* OnClick */ 18, [!valueState ? changeAction : ((_arg) => {
    })])]), singleton(onText)))), div_1(empty(), singleton(button(ofArray([new Option_2(/* Color */ 0, [!valueState ? Color_IColor.IsDanger : (algIsAllowed ? Color_IColor.NoColor : Color_IColor.IsWarning)]), new Option_2(/* OnClick */ 18, [(valueState && algIsAllowed) ? changeAction : ((_arg_1) => {
    })])]), singleton(algIsAllowed ? offText : "No Algebra"))))]))));
}

export const algebraKey = (() => {
    let s, s_2, s_5, s_8, s_17, s_20, s_23, s_26, s_29, s_33, s_37;
    const props_102 = [["style", {
        overflowY: "scroll",
    }]];
    const children_26 = [(s = "Algebraic expressions in Issie consist of input variables, numeric values,\r\n                and operators which manipulate them.", s), react_2.createElement("hr", {}), react_2.createElement("br", {}), h5(empty())(singleton("Variables")), (s_2 = "Variables in algebraic expressions correspond the input components in your\r\n                schematic, with the name of each variable being derived from the label of\r\n                each input. Each variable has a width associated with it, this is the same\r\n                as the width of its corresponding input component.", s_2), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Numeric Addition (+)")), react_2.createElement("b", {}, "Usage: A + B, Example: 1 + 2 = 3"), react_2.createElement("br", {}), (s_5 = "Represents the addition of two expressions, just like it would in maths.\r\n                The width of the result is equal to the width of the operands. If the result\r\n                exceeds the maximum value for the width, the value will wrap around. For example,\r\n                0xA + 0xB = 0x6 for a width of 4.", s_5), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Numeric Subtraction (-)")), react_2.createElement("b", {}, "Usage: A - B, Example 2 - 1 = 1"), react_2.createElement("br", {}), (s_8 = "Represents the subtraction of two expressions, just like it would in maths.\r\n                The width of the result is equal to the width of the operands. If the result\r\n                exceeds the maximum value for the width, the value will wrap around.", s_8), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Carry Of (carry())")), react_2.createElement("b", {}, "Usage: carry(X-Y+Z), Example: carry(0xA + 0xB) = 1, when width = 4"), react_2.createElement("br", {}), "Represents the carry-out of an arithmetic operation", react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Numeric Negation (-)")), react_2.createElement("b", {}, "Usage: -A, Example: - 5"), react_2.createElement("br", {}), "Shows that an expression is being negated, (times -1), like it would in maths.", react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Bitwise And (&)")), react_2.createElement("b", {}, "Usage: A & B, Example 0 & 1 = 0 "), react_2.createElement("br", {}), (s_17 = "Represents an AND operation between two expressions. This is a bitwise operation,\r\n                meaning that the operator is applied to each bit one-by-one. For example, for inputs\r\n                with a width of 8 bits: 0xFF & 0xFF = 0xFF", s_17), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Bitwise Or (|)")), react_2.createElement("b", {}, "Usage: A | B, Example: 0 | 1 = 1 "), react_2.createElement("br", {}), (s_20 = "Represents an OR operation between two expressions. This is a bitwise operation,\r\n                meaning that the operator is applied to each bit one-by-one. For example, for inputs\r\n                with a width of 8 bits: 0xFF | 0x01 = 0xFF.", s_20), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Bitwise Xor (⊕)")), react_2.createElement("b", {}, "Usage: A ⊕ B, Example: 0 ⊕ 1 = 1 "), react_2.createElement("br", {}), (s_23 = "Represents an XOR operation between two expressions. This is a bitwise operation,\r\n                meaning that the operator is applied to each bit one-by-one.", s_23), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Bitwise Not (~)")), react_2.createElement("b", {}, "Usage: ~A, Example: ~0 = 1 "), react_2.createElement("br", {}), (s_26 = "Represents an OR operation between two expressions. This is a bitwise operation,\r\n                meaning that the operator is applied to each bit one-by-one. For example, for an\r\n                input with a width of 4 bits: ~(0b1101) = ~(0b0010).", s_26), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Bit Range ([u:l])")), react_2.createElement("b", {}, "Usage: A[u:l], Example: (0b1101)[2:1] = 0b10"), react_2.createElement("br", {}), (s_29 = "Represents the selection of a specific range of bits from an expression. The upper\r\n                bound is the first number, and the lower bound is the second number in the brackets.\r\n                The bit range defined by these two numbers is inclusive. The width of the result is\r\n                equal to u + l - 1", s_29), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Append (::)")), react_2.createElement("b", {}, "Usage: A::B"), react_2.createElement("br", {}), react_2.createElement("b", {}, "Example: 0b1101 :: 0b1001 = 0b11011001"), react_2.createElement("br", {}), (s_33 = "Represents the joining of two expressions together, with the first expression making\r\n                up the MSBs, and the second the LSBs. The width of the result is the sum of the widths\r\n                of the two expressions beign appended.", s_33), react_2.createElement("br", {}), react_2.createElement("hr", {}), h5(empty())(singleton("Equals (==)")), react_2.createElement("b", {}, "Usage: A == number"), react_2.createElement("br", {}), react_2.createElement("b", {}, "Example: 0x05 == 0x05 = 1, 0x05 == 0x02 = 0"), react_2.createElement("br", {}), (s_37 = "Compares the value of an algebraic expression to a number. If the equality holds (true)\r\n                then the result is 1. Otherwise (false) the result is 0.", s_37), react_2.createElement("br", {})];
    return react_2.createElement("div", keyValueList(props_102, 1), ...children_26);
})();

export function createAlgKeyPopup(dispatch) {
    dynamicClosablePopup("Key for Algebraic Expressions", (x) => algebraKey, (_arg) => react_2.createElement("div", {}), ofArray([new CSSProp(/* Height */ 189, ["60%"]), new CSSProp(/* Width */ 395, ["30%"])]), dispatch);
}

/**
 * Checks if changing an input to Algebra/Values results in a valid simulation
 * (i.e. an AlgebraNotImplemented exception is not raised)
 */
export function validateAlgebraInput(io_, io__1, io__2, fsi, tableSD) {
    try {
        changeInputFData(io_, fsi, tableSD.ClockTickNumber, tableSD.FastSim);
        return new FSharpResult$2(/* Ok */ 0, [0]);
    }
    catch (matchValue) {
        if (matchValue instanceof AlgebraNotImplemented) {
            return new FSharpResult$2(/* Error */ 1, [matchValue.Data0]);
        }
        else {
            throw matchValue;
        }
    }
}

export function dialogPopupReductionBody(inputs, tableSD, dispatch, model$0027) {
    const dialogData = model$0027.PopupDialogData;
    let explanation;
    const s = "Reduce the Truth Table down into something more compact and informative by setting\r\n            certain inputs to your logic as algebra. The resultant new Truth Table will show\r\n            outputs as a function of your inputs. As algebraic inputs are directly evaluated by \r\n            the simulator, they are a great way to avoid Truth Table truncation.";
    explanation = s;
    let algInputs;
    const matchValue = dialogData.AlgebraInputs;
    algInputs = ((matchValue == null) ? toFail(printf("what? PopupDialogData.AlgebraInputs is None in popup body")) : matchValue);
    let toggles;
    const children = map((_arg_2) => {
        let zero, tryAlg;
        const io_1 = _arg_2;
        const isValInput = !contains(io_1, algInputs, {
            Equals: equalArrays,
            GetHashCode: (x) => (arrayHash(x) | 0),
        });
        const toggle = makeOnOffToggle(isValInput ? ((zero = (new FSInterface(/* IData */ 0, [new FastData(new FastBits(/* Word */ 0, [0]), io_1[2])])), (tryAlg = validateAlgebraInput(io_1[0], io_1[1], io_1[2], new FSInterface(/* IAlg */ 1, [new FastAlgExp(/* SingleTerm */ 0, [io_1])]), tableSD), (void validateAlgebraInput(io_1[0], io_1[1], io_1[2], zero, tableSD), Result_IsOk(tryAlg))))) : true, isValInput, (_arg_1) => {
            dispatch(new Msg(/* TruthTableMsg */ 32, [new TTMsg(/* TogglePopupAlgebraInput */ 22, [[io_1, tableSD]])]));
        }, "Values", "Algebra");
        return makeElementLine(singleton(toString(io_1[1])), singleton(toggle));
    }, inputs);
    const props = singleton(["style", {
        width: "400px",
    }]);
    toggles = react_2.createElement("div", keyValueList(props, 1), ...children);
    let error;
    const matchValue_1 = dialogData.AlgebraError;
    if (matchValue_1 != null) {
        if (matchValue_1.InDependency != null) {
            const d = matchValue_1.InDependency;
            const t = matchValue_1.ErrType;
            const children_5 = [errorMessage(dispatch, errMsg(t)), react_2.createElement("br", {}), concat("Component in question: ", d)];
            error = react_2.createElement("div", {}, ...children_5);
        }
        else {
            error = toFail(printf("what? SimError for AlgebraNotImplemented should always have an\r\n                    InDependency field. Error: %A"))(dialogData.AlgebraError);
        }
    }
    else {
        error = react_2.createElement("div", {});
    }
    const children_7 = [explanation, react_2.createElement("hr", {}), toggles, react_2.createElement("hr", {}), error];
    return react_2.createElement("div", {}, ...children_7);
}

export function createAlgReductionPopup(model, dispatch) {
    let patternInput;
    const matchValue = model.CurrentTruthTable;
    if (matchValue != null) {
        const copyOfStruct = matchValue;
        patternInput = ((copyOfStruct.tag === 0) ? [map((cell) => {
            const matchValue_1 = cell.IO;
            if (matchValue_1.tag === 1) {
                return toFail(printf("what? Found viewer in Truth Table inputs"));
            }
            else {
                return matchValue_1.fields[0];
            }
        }, head(map((tuple) => tuple[0], toList(copyOfStruct.fields[0].TableMap)))), copyOfStruct.fields[0].TableSimData] : toFail(printf("what? Reduction option should not exist when there is TT error")));
    }
    else {
        patternInput = toFail(printf("what? No current Truth Table when reducing"));
    }
    dialogPopup("Reduction using Algebraic Inputs", (model$0027) => dialogPopupReductionBody(patternInput[0], patternInput[1], dispatch, model$0027), "Apply", (model$0027_1) => {
        const matchValue_2 = model$0027_1.PopupDialogData.AlgebraInputs;
        if (matchValue_2 != null) {
            dispatch(new Msg(/* TruthTableMsg */ 32, [new TTMsg(/* SetTTAlgebraInputs */ 19, [matchValue_2])]));
            dispatch(Msg.ClosePopup);
        }
        else {
            toFail(printf("what? what? PopupDialogData.AlgebraInputs is None in popup body"));
        }
    }, (model$0027_2) => {
        const dialogData_1 = model$0027_2.PopupDialogData;
        const matchValue_3 = dialogData_1.AlgebraInputs;
        let matchResult, lst;
        if (dialogData_1.AlgebraError == null) {
            if (matchValue_3 != null) {
                if (isEmpty(matchValue_3)) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                    lst = matchValue_3;
                }
            }
            else {
                matchResult = 0;
            }
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }, empty(), dispatch);
}

export function viewReductions(table, model, dispatch) {
    const ttDispatch = (ttMsg) => {
        dispatch(new Msg(/* TruthTableMsg */ 32, [ttMsg]));
    };
    let goBackButton;
    const matchValue_1 = model.TTConfig.AlgebraIns;
    goBackButton = ((table.DCMap == null) ? (isEmpty(matchValue_1) ? react_2.createElement("div", {}) : button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsInfo]), new Option_2(/* OnClick */ 18, [(_arg_1) => {
        ttDispatch(new TTMsg(/* SetTTAlgebraInputs */ 19, [empty()]));
        ttDispatch(new TTMsg(/* SetPopupAlgebraInputs */ 33, [empty()]));
    }])]), singleton("Back to Numeric Table"))) : (isEmpty(matchValue_1) ? button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsInfo]), new Option_2(/* OnClick */ 18, [(_arg) => {
        ttDispatch(TTMsg.ClearDCMap);
    }])]), singleton("Back to Full Table")) : toFail(printf("what? Table cannot be DC Reduced and Algebraic"))));
    const reduceButton = table.IsTruncated ? button(ofArray([new Option_2(/* Disabled */ 16, [true]), new Option_2(/* OnClick */ 18, [(_arg_2) => {
    }])]), singleton(addToolTipTop("DC Reduction unavailable for truncated tables", "Remove Redundancies"))) : (!table.HasRedundancies ? button(ofArray([new Option_2(/* Disabled */ 16, [true]), new Option_2(/* OnClick */ 18, [(_arg_3) => {
    }])]), singleton(addToolTipTop("No redundancies to remove", "Remove Redundancies"))) : button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsSuccess]), new Option_2(/* OnClick */ 18, [(_arg_4) => {
        ttDispatch(TTMsg.DCReduceTruthTable);
    }])]), singleton("Remove Redundancies")));
    const algebraButton = button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsSuccess]), new Option_2(/* OnClick */ 18, [(_arg_5) => {
        createAlgReductionPopup(model, dispatch);
    }])]), singleton("Algebra"));
    const keyButton = button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsInfo]), new Option_2(/* OnClick */ 18, [(_arg_6) => {
        createAlgKeyPopup(dispatch);
    }])]), singleton("Key"));
    const algebraTags = list_3(empty(), map((tupledArg) => tag_52(ofArray([new Option(/* Color */ 1, [Color_IColor.IsDanger]), Option.IsLight]), singleton(toString(tupledArg[1]))), model.TTConfig.AlgebraIns));
    const hasMultiBitOutputs = !isEmpty(filter((tupledArg_1) => (tupledArg_1[2] > 1), table.TableSimData.Outputs));
    const maybeBaseSelector = hasMultiBitOutputs ? baseSelector(table.TableSimData.NumberBase, (n) => {
        ttDispatch(new TTMsg(/* SetTTBase */ 20, [n]));
    }) : react_2.createElement("div", {});
    const matchValue_3 = table.DCMap;
    const matchValue_4 = model.TTConfig.AlgebraIns;
    if (matchValue_3 != null) {
        if (!isEmpty(matchValue_4)) {
            return toFail(printf("what? Table cannot be DC Reduced and Algebraic"));
        }
        else {
            const dc = matchValue_3;
            const children_7 = [makeElementLine(singleton(goBackButton), singleton(maybeBaseSelector))];
            return react_2.createElement("div", {}, ...children_7);
        }
    }
    else if (!isEmpty(matchValue_4)) {
        const children_9 = [makeElementLine(ofArray([goBackButton, "   ", algebraButton, "   ", keyButton]), singleton(maybeBaseSelector)), makeElementLine(ofArray(["Algebraic Inputs: ", algebraTags]), empty())];
        return react_2.createElement("div", {}, ...children_9);
    }
    else {
        const children_5 = [makeElementLine(ofArray([reduceButton, "   ", algebraButton]), singleton(maybeBaseSelector))];
        return react_2.createElement("div", {}, ...children_5);
    }
}

